import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import useHeaderOverlay from './useHeaderOverlay';

const HeaderOverlayContext = createContext(null);

function HeaderOverlayProvider({ children }) {
    const overlay = useHeaderOverlay();
    return (
        <HeaderOverlayContext.Provider value={overlay}>
            {children}
        </HeaderOverlayContext.Provider>
    );
}

HeaderOverlayProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

function useHeaderOverlayContext() {
    const overlay = useContext(HeaderOverlayContext);
    if (!overlay) {
        throw new Error('useHeaderOverlayContext must be used within HeaderOverlayProvider');
    }
    return overlay;
}

export { HeaderOverlayContext, HeaderOverlayProvider, useHeaderOverlayContext };
export default HeaderOverlayContext;
